import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import App from "./App.vue";
import store from "./store";

import providerPage from "./components/providerPage";
import loginPage from "./components/loginPage";
import searchPage from "./components/searchPage";
import submitPage from "./components/submitPage";
import contactPage from "./components/contactPage";
import generalInfoPage from "./components/generalInfoPage";
import keyFactsPage from "./components/keyFactsPage";
import localePage from "./components/localePage";
import dealPage from "./components/dealPage";
import gcicPage from "./components/gcicPage";

const routes = [
  {
    path: "/",
    component: {
      template: "<router-view></router-view>"
    },
    redirect: { name: "search" },
    name: "app",
    children: [
      {
        path: "/provider",
        component: providerPage,
        name: "provider",
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/login",
        component: loginPage,
        name: "login"
      },
      {
        path: "/submit",
        component: submitPage,
        name: "submit",
        meta: { requiresAuth: true }
      },
      {
        path: "/search",
        component: searchPage,
        name: "search",
        meta: { requiresAuth: true }
      },
      {
        path: "/general-info",
        component: generalInfoPage,
        meta: {
          requiresAuth: true
        },
        name: "general-info"
      },
      {
        path: "/key-statistics",
        component: keyFactsPage,
        meta: {
          requiresAuth: true
        },
        name: "key-statistics"
      },
      {
        path: "/contact",
        component: contactPage,
        meta: {
          requiresAuth: true
        },
        name: "contact-page"
      },
      {
        path: "/locale",
        component: localePage,
        meta: {
          requiresAuth: true
        },
        name: "locale-page"
      },
      {
        path: "/deal",
        component: dealPage,
        meta: {
          requiresAuth: true
        },
        name: "deal-page"
      },
      {
        path: "/gcic",
        component: gcicPage,
        meta: {
          requiresAuth: true
        },
        name: "gcic-page"
      }
    ]
  },
  { path: "*", component: App, redirect: { name: "login" } }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    !store.getters.authenticated
  ) {
    if (to.query.id != undefined && to.query.token != undefined) {
      store.commit("setToken", { access_token: to.query.token });
      store.dispatch("getBaseData");
      store.commit("setOneTimeAccess", true);
      store
        .dispatch("fetchProviderForEdit", to.query.id)
        .then(r => {
          store.commit("setEditMode");
          next();
        })
        .catch(() => {
          store.commit("setToken", { access_token: "" });
          router.push({ name: "login" });
        });
    } else {
      router.push({ name: "login" });
    }
  } else if (to.query.id != undefined) {
    store.commit("setOneTimeAccess", false);
    store.commit("setEditMode");
    store.dispatch("fetchProviderForEdit", to.query.id);
    store.commit("setposition", to.name);

    if (to.query.token) {
      store.commit("setOneTimeAccess", true);
    }

    next();
  }
  store.commit("setposition", to.name);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js